<template>
  <div>
    <div
      class="searchBox"
      :style="isMobile && !showSearch && isSitePage ? 'right: -30px' : ''"
    >
      <i class="clearable" v-show="showSearch" @click="onClickClose">&times;</i>

      <b-form-input
        id="input-search"
        ref="refSearch"
        type="text"
        v-model="keyword"
        class="searchInput"
        placeholder="Search"
        :style="
          showSearch
            ? `height: 100%; background: #60A6EA 0% 0% no-repeat padding-box; padding-left: 42px; ${
                isMobile && isSitePage
                  ? 'width: 91vw'
                  : isMobile && !isSitePage
                  ? 'width: 70vw'
                  : 'width: 300px'
              }`
            : ''
        "
        @keyup="onSearchBoard($event)"
      ></b-form-input>

      <ul v-show="results.length > 0" @mousedown.prevent>
        <li
          class="search-list-item"
          v-for="(result, index) in results"
          :key="index"
          :class="{ selected: curIndex === index }"
          @click="goToBoardSchedule(result.board_id, result.site_name)"
        >
          <div
            v-html="
              formatBodyText(`${result.board_name}, ${result.board_location}`)
            "
          ></div>
          <div
            class="ml-3"
            v-if="result.parent_board_id"
            v-html="
              formatBodyText(
                `${result.parent_board_name}, ${
                  result.parent_board_location
                }, ${result.site_name}`
              )
            "
          ></div>
          <div
            class="ml-3"
            v-else
            v-html="formatBodyText(`${result.site_name}`)"
          ></div>
        </li>
      </ul>

      <b-img
        width="15"
        class="search-icon rounded-0"
        :style="!showSearch ? '' : 'position: absolute; left: 16px'"
        :src="require('@/assets/icons/search.svg')"
        @click="onClickSearch"
      ></b-img>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import debounce from 'lodash/debounce'

const KEYCODE = {
  UP: 38,
  DOWN: 40,
  ENTER: 13
}

export default {
  data() {
    return {
      showSearch: false,
      keyword: null,
      results: [],
      curIndex: -1
    }
  },

  computed: {
    ...mapState({
      site: state => state.site.list,
      board: state => state.board.list
    }),

    isSitePage() {
      return this.$router.currentRoute.name === 'site.view-site-page'
    }
  },

  methods: {
    onClickSearch() {
      if (
        this.site.length > 0 ||
        this.board.list > 0 ||
        this.isSitePage ||
        this.$router.currentRoute.name === 'site.view-change-log'
      ) {
        this.showSearch = true
        this.$nextTick(() => {
          this.$refs.refSearch.focus()
        })
        this.$emit('open')
      }
    },

    onClickClose() {
      this.showSearch = false
      this.keyword = null
      this.results = []
      this.curIndex = -1
      this.$emit('close')
    },

    formatBodyText(body) {
      let matches = body.match(new RegExp(this.keyword, 'gi'))
      if (matches) {
        for (let i = 0; i < matches.length; i++) {
          let keyword = matches[i]
          body = body.replace(keyword, `<b>${keyword}</b>`)
        }
      }

      return body
    },

    goToBoardSchedule(boardId, siteName) {
      this.$router.push({
        name: 'board.board-details-page',
        params: {
          id: boardId,
          name: siteName
        }
      })
    },

    onSearchBoard(e) {
      this.keyword = e.target.value
      if (!this.keyword) {
        this.results = []
        return
      }

      if (e.keyCode === KEYCODE.UP && this.curIndex > -1) {
        this.curIndex--
      } else if (
        e.keyCode === KEYCODE.DOWN &&
        this.curIndex < this.results.length - 1
      ) {
        this.curIndex++
      } else if (e.keyCode === KEYCODE.ENTER) {
        this.goToBoardSchedule(
          this.results[this.curIndex].board_id,
          this.results[this.curIndex].site_name
        )
      } else {
        this.goSearch()
      }
    },

    goSearch: debounce(function() {
      this.searchBoard()
    }, 200),

    async searchBoard() {
      await this.$api
        .get(`/search?keyword=${this.keyword}&limit=5`)
        .then(({ data }) => {
          this.results = data.data
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-icon {
  margin-top: 16px;
  margin-right: 16px;
}
.clearable {
  margin-top: -4px;
  color: white;
}
.searchBox {
  position: absolute;
  transform: translate(-100%, 100%);
  background: #ffffff33 0% 0% no-repeat padding-box;
  height: 46px;
  border-radius: 8px;
  margin-top: -45px;
  cursor: pointer;
}
.searchButton {
  color: white;
  float: right;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.4s;
}
.searchInput {
  border: none;
  background: none;
  outline: none;
  float: left;
  padding: 0;
  font-size: 16px;
  transition: 0.4s;
  width: 0px;
  padding: 10px 16px;
  padding-right: 0;
  color: white;
  max-width: calc(1140px - 186px) !important;

  &::placeholder {
    color: white;
    opacity: 0.5;
  }

  @media (max-width: 768px) {
    max-width: calc(100vw - 186px) !important;
  }
}
ul {
  position: absolute;
  z-index: 2;
  list-style-type: none;
  margin: 0;
  padding: 0;
  background: #f8f9fa;
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  margin-top: 55px;
  cursor: pointer;
  overflow: hidden;

  li {
    padding: 8px 16px;
    color: black;
    text-shadow: none;

    &:hover {
      background: #296dc529;
    }
  }
}
.search-list-item.selected {
  background: #296dc529;
}
</style>
